export type TabKey =
  | 'hero'
  | 'about_preview'
  | 'cta'
  | 'services_home'
  | 'whyus'
  | 'how'
  | 'reviews'
  | 'about'
  | 'faq'
  | 'services'
  | 'contact'
  | 'common'
  | 'images'
  | 'stats';

export interface TabMeta {
  key: TabKey;
  label: string;
  icon: string;
  namespace: string;
}

export interface FieldDef {
  key: string;
  label: string;
  desc?: string;
  multiline?: boolean;
  section?: string;
}

export const TABS: TabMeta[] = [
  { key: 'hero', label: 'Hero & Stats', icon: 'ri-home-line', namespace: 'home' },
  { key: 'about_preview', label: 'About Preview', icon: 'ri-user-line', namespace: 'home' },
  { key: 'cta', label: 'CTA Section', icon: 'ri-megaphone-line', namespace: 'home' },
  { key: 'services_home', label: 'Services', icon: 'ri-tools-line', namespace: 'home' },
  { key: 'whyus', label: 'Our Values', icon: 'ri-heart-line', namespace: 'home' },
  { key: 'how', label: 'How It Works', icon: 'ri-list-check-2', namespace: 'home' },
  { key: 'reviews', label: 'Reviews', icon: 'ri-star-line', namespace: 'home' },
  { key: 'about', label: 'About Us', icon: 'ri-information-line', namespace: 'about' },
  { key: 'faq', label: 'FAQs', icon: 'ri-questionnaire-line', namespace: 'about' },
  { key: 'services', label: 'Services Page', icon: 'ri-briefcase-line', namespace: 'services' },
  { key: 'contact', label: 'Contact Info', icon: 'ri-mail-line', namespace: 'contact' },
  { key: 'common', label: 'General', icon: 'ri-settings-line', namespace: 'common' },
  { key: 'images', label: 'Media', icon: 'ri-image-line', namespace: 'images' },
  { key: 'stats', label: 'Performance', icon: 'ri-bar-chart-line', namespace: 'stats' },
];

export const TAB_FIELDS: Record<TabKey, FieldDef[]> = {
  hero: [
    { key: 'hero_badge', label: 'Insignia del Hero', desc: 'Texto pequeño arriba del título' },
    { key: 'hero_title', label: 'Título Principal', desc: 'Título grande del Hero', multiline: true },
    { key: 'hero_desc', label: 'Descripción del Hero', desc: 'Texto debajo del título', multiline: true },
    { key: 'hero_location', label: 'Ubicación', desc: 'Texto de la tarjeta de ubicación' },
    { key: 'hero_local', label: 'Local y de Confianza', desc: 'Subtítulo de ubicación' },
    { key: 'hero_flexible', label: 'Horario Flexible', desc: 'Texto de la tarjeta de horario' },
    { key: 'hero_flexible_sub', label: 'Subtítulo Horario' },
    { key: 'hero_free_quote', label: 'Presupuestos Gratis', desc: 'Texto de la tarjeta de presupuesto' },
    { key: 'hero_free_quote_sub', label: 'Subtítulo Presupuesto' },
    { key: 'hero_stat_years', label: 'Estadística: Años de Experiencia' },
    { key: 'hero_stat_satisfaction', label: 'Estadística: Satisfacción' },
    { key: 'hero_stat_free', label: 'Estadística: Términos y Condiciones' },
    { key: 'hero_stat_local', label: 'Estadística: Negocio Familiar' },
    { key: 'hero_form_title', label: 'Título del Formulario', desc: 'Título del formulario en el Hero' },
    { key: 'hero_form_subtitle', label: 'Subtítulo del Formulario' },
    { key: 'hero_placeholder_name', label: 'Placeholder Nombre' },
    { key: 'hero_placeholder_email', label: 'Placeholder Email' },
    { key: 'hero_placeholder_phone', label: 'Placeholder Teléfono' },
    { key: 'hero_submit', label: 'Texto del Botón Enviar' },
    { key: 'stats_experience', label: 'Stats: Título Experiencia' },
    { key: 'stats_experience_desc', label: 'Stats: Desc Experiencia', multiline: true },
    { key: 'stats_satisfaction', label: 'Stats: Título Satisfacción' },
    { key: 'stats_satisfaction_desc', label: 'Stats: Desc Satisfacción', multiline: true },
    { key: 'stats_free', label: 'Stats: Título Presupuestos' },
    { key: 'stats_free_word', label: 'Stats: Palabra Grande (Gratis/Free)' },
    { key: 'stats_free_desc', label: 'Stats: Desc Presupuestos', multiline: true },
    { key: 'stats_local', label: 'Stats: Título Local' },
    { key: 'stats_local_word', label: 'Stats: Palabra Grande (Local)' },
    { key: 'stats_local_desc', label: 'Stats: Desc Local', multiline: true },
  ],
  about_preview: [
    { key: 'about_badge', label: 'Insignia Sobre Nosotros' },
    { key: 'about_title', label: 'Título Sobre Nosotros', multiline: true },
    { key: 'about_desc1', label: 'Descripción 1', multiline: true },
    { key: 'about_desc2', label: 'Descripción 2', multiline: true },
    { key: 'about_serving', label: 'Sirviendo a' },
    { key: 'about_service_spray', label: 'Servicio: Espuma Spray' },
    { key: 'about_service_batt', label: 'Servicio: Paneles y Rollos' },
    { key: 'about_service_attic', label: 'Servicio: Ático y Paredes' },
    { key: 'about_service_commercial', label: 'Servicio: Comercial' },
  ],
  cta: [
    { key: 'cta_badge', label: 'Insignia CTA Banner' },
    { key: 'cta_title', label: 'Título CTA Banner', multiline: true },
    { key: 'cta_desc', label: 'Descripción CTA Banner', multiline: true },
    { key: 'finalcta_badge', label: 'Insignia CTA Final' },
    { key: 'finalcta_title', label: 'Título CTA Final', multiline: true },
    { key: 'finalcta_desc', label: 'Descripción CTA Final', multiline: true },
  ],
  services_home: [
    { key: 'services_badge', label: 'Insignia Servicios' },
    { key: 'services_title', label: 'Título Servicios', multiline: true },
    { key: 'services_desc', label: 'Descripción Servicios', multiline: true },
    { key: 'services_area_title', label: 'Área: Texto Grande' },
    { key: 'services_area_label', label: 'Área: Etiqueta' },
    { key: 'services_area_sub', label: 'Área: Subtítulo' },
    { key: 'services_section_title', label: 'Tarjetas: Título' },
    { key: 'services_section_desc', label: 'Tarjetas: Descripción', multiline: true },
    { key: 'services_card1_title', label: 'Tarjeta 1: Título (Espuma Spray)' },
    { key: 'services_card1_desc', label: 'Tarjeta 1: Descripción', multiline: true },
    { key: 'services_card2_title', label: 'Tarjeta 2: Título (Paneles)' },
    { key: 'services_card2_desc', label: 'Tarjeta 2: Descripción', multiline: true },
    { key: 'services_card3_title', label: 'Tarjeta 3: Título (Celulosa)' },
    { key: 'services_card3_desc', label: 'Tarjeta 3: Descripción', multiline: true },
    { key: 'services_overlay_reliable', label: 'Overlay: Confiable' },
    { key: 'services_overlay_reliable_desc', label: 'Overlay: Desc Confiable', multiline: true },
    { key: 'services_overlay_free', label: 'Overlay: Presupuestos' },
    { key: 'services_overlay_free_desc', label: 'Overlay: Desc Presupuestos', multiline: true },
  ],
  whyus: [
    { key: 'whyus_badge', label: 'Insignia Por Qué Elegirnos' },
    { key: 'whyus_title', label: 'Título Por Qué Elegirnos', multiline: true },
    { key: 'whyus_desc', label: 'Descripción Por Qué Elegirnos', multiline: true },
    { key: 'whyus_bar_customer', label: 'Barra: Satisfacción del Cliente' },
    { key: 'whyus_bar_timely', label: 'Barra: Proyectos a Tiempo' },
    { key: 'whyus_bar_reliable', label: 'Barra: Fiabilidad' },
    { key: 'whyus_bar_quality', label: 'Barra: Calidad' },
  ],
  how: [
    { key: 'how_badge', label: 'Insignia Cómo Funciona' },
    { key: 'how_title', label: 'Título Cómo Funciona', multiline: true },
    { key: 'how_step1_title', label: 'Paso 1: Título' },
    { key: 'how_step1_desc', label: 'Paso 1: Descripción', multiline: true },
    { key: 'how_step2_title', label: 'Paso 2: Título' },
    { key: 'how_step2_desc', label: 'Paso 2: Descripción', multiline: true },
    { key: 'how_step3_title', label: 'Paso 3: Título' },
    { key: 'how_step3_desc', label: 'Paso 3: Descripción', multiline: true },
    { key: 'how_step4_title', label: 'Paso 4: Título' },
    { key: 'how_step4_desc', label: 'Paso 4: Descripción', multiline: true },
  ],
  reviews: [
    { key: 'reviews_google', label: 'Reseñas: Google' },
    { key: 'reviews_google_sub', label: 'Reseñas: Subtítulo Google' },
    { key: 'reviews_title', label: 'Reseñas: Título Sección', multiline: true },
    { key: 'reviews_desc', label: 'Reseñas: Descripción', multiline: true },
    { key: 'reviews_rating', label: 'Reseñas: Rating' },
    { key: 'reviews_verified', label: 'Reseñas: Verificadas' },
    { key: 'reviews_leave', label: 'Reseñas: Botón Dejar Reseña' },
    { key: 'reviews_client1_name', label: 'Cliente 1: Nombre' },
    { key: 'reviews_client1_date', label: 'Cliente 1: Fecha' },
    { key: 'reviews_client1_text', label: 'Cliente 1: Reseña', multiline: true },
    { key: 'reviews_client2_name', label: 'Cliente 2: Nombre' },
    { key: 'reviews_client2_date', label: 'Cliente 2: Fecha' },
    { key: 'reviews_client2_text', label: 'Cliente 2: Reseña', multiline: true },
    { key: 'reviews_client3_name', label: 'Cliente 3: Nombre' },
    { key: 'reviews_client3_date', label: 'Cliente 3: Fecha' },
    { key: 'reviews_client3_text', label: 'Cliente 3: Reseña', multiline: true },
    { key: 'reviews_client4_name', label: 'Cliente 4: Nombre' },
    { key: 'reviews_client4_date', label: 'Cliente 4: Fecha' },
    { key: 'reviews_client4_text', label: 'Cliente 4: Reseña', multiline: true },
    { key: 'reviews_client5_name', label: 'Cliente 5: Nombre' },
    { key: 'reviews_client5_date', label: 'Cliente 5: Fecha' },
    { key: 'reviews_client5_text', label: 'Cliente 5: Reseña', multiline: true },
    { key: 'reviews_client6_name', label: 'Cliente 6: Nombre' },
    { key: 'reviews_client6_date', label: 'Cliente 6: Fecha' },
    { key: 'reviews_client6_text', label: 'Cliente 6: Reseña', multiline: true },
    { key: 'reviews_client7_name', label: 'Cliente 7: Nombre' },
    { key: 'reviews_client7_date', label: 'Cliente 7: Fecha' },
    { key: 'reviews_client7_text', label: 'Cliente 7: Reseña', multiline: true },
    { key: 'reviews_client8_name', label: 'Cliente 8: Nombre' },
    { key: 'reviews_client8_date', label: 'Cliente 8: Fecha' },
    { key: 'reviews_client8_text', label: 'Cliente 8: Reseña', multiline: true },
    { key: 'reviews_client9_name', label: 'Cliente 9: Nombre' },
    { key: 'reviews_client9_date', label: 'Cliente 9: Fecha' },
    { key: 'reviews_client9_text', label: 'Cliente 9: Reseña', multiline: true },
  ],
  about: [
    { key: 'about_hero_title', label: 'Título Hero de Nosotros' },
    { key: 'story_badge', label: 'Insignia Nuestra Historia' },
    { key: 'story_title', label: 'Título Nuestra Historia', multiline: true },
    { key: 'story_desc1', label: 'Historia: Descripción 1', multiline: true },
    { key: 'story_desc2', label: 'Historia: Descripción 2', multiline: true },
    { key: 'story_serving', label: 'Historia: Sirviendo a' },
    { key: 'story_tagline', label: 'Historia: Tagline' },
    { key: 'story_years', label: 'Historia: Años de' },
    { key: 'story_experience', label: 'Historia: Experiencia' },
    { key: 'story_satisfaction', label: 'Historia: Satisfacción' },
    { key: 'story_guaranteed', label: 'Historia: Garantizada' },
    { key: 'story_free', label: 'Historia: Presupuestos' },
    { key: 'story_available', label: 'Historia: Disponibles' },
    { key: 'vision_title', label: 'Visión: Título', multiline: true },
    { key: 'vision_desc', label: 'Visión: Descripción', multiline: true },
  ],
  faq: [
    { key: 'faq_badge', label: 'Insignia FAQ' },
    { key: 'faq_title', label: 'Título FAQ', multiline: true },
    { key: 'faq_desc', label: 'Descripción FAQ', multiline: true },
    { key: 'faq_q1', label: 'Pregunta 1', multiline: true },
    { key: 'faq_a1', label: 'Respuesta 1', multiline: true },
    { key: 'faq_q2', label: 'Pregunta 2', multiline: true },
    { key: 'faq_a2', label: 'Respuesta 2', multiline: true },
    { key: 'faq_q3', label: 'Pregunta 3', multiline: true },
    { key: 'faq_a3', label: 'Respuesta 3', multiline: true },
    { key: 'faq_q4', label: 'Pregunta 4', multiline: true },
    { key: 'faq_a4', label: 'Respuesta 4', multiline: true },
    { key: 'faq_q5', label: 'Pregunta 5', multiline: true },
    { key: 'faq_a5', label: 'Respuesta 5', multiline: true },
    { key: 'faq_q6', label: 'Pregunta 6', multiline: true },
    { key: 'faq_a6', label: 'Respuesta 6', multiline: true },
    { key: 'approach_badge', label: 'Insignia Enfoque' },
    { key: 'approach_title', label: 'Título Enfoque', multiline: true },
    { key: 'approach_desc', label: 'Descripción Enfoque', multiline: true },
    { key: 'approach_value1_title', label: 'Valor 1: Título' },
    { key: 'approach_value1_desc', label: 'Valor 1: Descripción', multiline: true },
    { key: 'approach_value2_title', label: 'Valor 2: Título' },
    { key: 'approach_value2_desc', label: 'Valor 2: Descripción', multiline: true },
    { key: 'approach_value3_title', label: 'Valor 3: Título' },
    { key: 'approach_value3_desc', label: 'Valor 3: Descripción', multiline: true },
    { key: 'approach_value4_title', label: 'Valor 4: Título' },
    { key: 'approach_value4_desc', label: 'Valor 4: Descripción', multiline: true },
    { key: 'approach_value5_title', label: 'Valor 5: Título' },
    { key: 'approach_value5_desc', label: 'Valor 5: Descripción', multiline: true },
  ],
  services: [
    { key: 'services_hero_title', label: 'Título Hero Servicios' },
    { key: 'services_badge', label: 'Insignia Servicios' },
    { key: 'services_title', label: 'Título Sección', multiline: true },
    { key: 'services_desc', label: 'Descripción Sección', multiline: true },
    { key: 'svc1_title', label: 'Servicio 1: Título (Espuma Spray)' },
    { key: 'svc1_desc', label: 'Servicio 1: Descripción', multiline: true },
    { key: 'svc2_title', label: 'Servicio 2: Título (Paneles)' },
    { key: 'svc2_desc', label: 'Servicio 2: Descripción', multiline: true },
    { key: 'svc3_title', label: 'Servicio 3: Título (Celulosa)' },
    { key: 'svc3_desc', label: 'Servicio 3: Descripción', multiline: true },
    { key: 'svc4_title', label: 'Servicio 4: Título (Ático)' },
    { key: 'svc4_desc', label: 'Servicio 4: Descripción', multiline: true },
    { key: 'svc5_title', label: 'Servicio 5: Título (Sótano)' },
    { key: 'svc5_desc', label: 'Servicio 5: Descripción', multiline: true },
    { key: 'svc6_title', label: 'Servicio 6: Título (Metálicos)' },
    { key: 'svc6_desc', label: 'Servicio 6: Descripción', multiline: true },
    { key: 'areas_badge', label: 'Áreas: Insignia' },
    { key: 'areas_title', label: 'Áreas: Título', multiline: true },
    { key: 'areas_desc', label: 'Áreas: Descripción', multiline: true },
    { key: 'area_lafayette', label: 'Área: Lafayette' },
    { key: 'area_lafayette_desc', label: 'Área: Desc Lafayette', multiline: true },
    { key: 'area_west_lafayette', label: 'Área: West Lafayette' },
    { key: 'area_west_lafayette_desc', label: 'Área: Desc West Lafayette', multiline: true },
    { key: 'area_surrounding', label: 'Área: Comunidades Cercanas' },
    { key: 'area_surrounding_desc', label: 'Área: Desc Comunidades', multiline: true },
    { key: 'cta_title', label: 'CTA: Título', multiline: true },
    { key: 'cta_desc', label: 'CTA: Descripción', multiline: true },
  ],
  contact: [
    { key: 'contact_hero_title', label: 'Título Hero Contacto' },
    { key: 'quick_call', label: 'Tarjeta: Llámanos' },
    { key: 'quick_email', label: 'Tarjeta: Email' },
    { key: 'quick_follow', label: 'Tarjeta: Síguenos' },
    { key: 'quick_area', label: 'Tarjeta: Área' },
    { key: 'panel_company', label: 'Panel: Empresa' },
    { key: 'panel_desc', label: 'Panel: Descripción', multiline: true },
    { key: 'panel_area_title', label: 'Panel: Título Área' },
    { key: 'panel_area_main', label: 'Panel: Área Principal' },
    { key: 'panel_area_sub', label: 'Panel: Área Sub' },
    { key: 'panel_hours_title', label: 'Panel: Título Horario' },
    { key: 'panel_hours_weekdays', label: 'Panel: Horario Semana' },
    { key: 'panel_hours_weekends', label: 'Panel: Horario Finde' },
    { key: 'panel_why_title', label: 'Panel: Por Qué Título' },
    { key: 'panel_why_1', label: 'Panel: Razón 1' },
    { key: 'panel_why_2', label: 'Panel: Razón 2' },
    { key: 'panel_why_3', label: 'Panel: Razón 3' },
    { key: 'panel_why_4', label: 'Panel: Razón 4' },
    { key: 'panel_cta', label: 'Panel: CTA', multiline: true },
    { key: 'form_badge', label: 'Form: Insignia' },
    { key: 'form_title', label: 'Form: Título', multiline: true },
    { key: 'form_placeholder_name', label: 'Form: Placeholder Nombre' },
    { key: 'form_placeholder_last', label: 'Form: Placeholder Apellido' },
    { key: 'form_placeholder_email', label: 'Form: Placeholder Email' },
    { key: 'form_placeholder_phone', label: 'Form: Placeholder Teléfono' },
    { key: 'form_placeholder_address', label: 'Form: Placeholder Dirección' },
    { key: 'form_placeholder_message', label: 'Form: Placeholder Mensaje' },
    { key: 'form_char_count', label: 'Form: Contador Caracteres (usar {{count}})' },
    { key: 'form_submit', label: 'Form: Botón Enviar' },
  ],
  common: [
    { key: 'nav_home', label: 'Nav: Inicio' },
    { key: 'nav_about', label: 'Nav: Nosotros' },
    { key: 'nav_services', label: 'Nav: Servicios' },
    { key: 'nav_contact', label: 'Nav: Contacto' },
    { key: 'nav_call_us', label: 'Nav: Llámanos' },
    { key: 'nav_get_quote', label: 'Nav: Cotizar' },
    { key: 'footer_company_desc', label: 'Footer: Descripción', multiline: true },
    { key: 'footer_phone', label: 'Footer: Teléfono' },
    { key: 'footer_email', label: 'Footer: Email' },
    { key: 'footer_navigation', label: 'Footer: Navegación' },
    { key: 'footer_nav_home', label: 'Footer: Link Inicio' },
    { key: 'footer_nav_services', label: 'Footer: Link Servicios' },
    { key: 'footer_nav_about', label: 'Footer: Link Nosotros' },
    { key: 'footer_nav_contact', label: 'Footer: Link Contacto' },
    { key: 'footer_our_services', label: 'Footer: Nuestros Servicios' },
    { key: 'footer_service_spray_foam', label: 'Footer: Servicio Espuma' },
    { key: 'footer_service_batt', label: 'Footer: Servicio Paneles' },
    { key: 'footer_service_cellulose', label: 'Footer: Servicio Celulosa' },
    { key: 'footer_service_attic', label: 'Footer: Servicio Ático' },
    { key: 'footer_service_walls', label: 'Footer: Servicio Paredes' },
    { key: 'footer_service_crawl', label: 'Footer: Servicio Sótano' },
    { key: 'footer_contact', label: 'Footer: Contacto' },
    { key: 'footer_address_line1', label: 'Footer: Dirección 1' },
    { key: 'footer_address_line2', label: 'Footer: Dirección 2' },
    { key: 'footer_hours_title', label: 'Footer: Título Horario' },
    { key: 'footer_hours_weekdays', label: 'Footer: Horario Semana' },
    { key: 'footer_hours_weekends', label: 'Footer: Horario Finde' },
    { key: 'footer_copyright', label: 'Footer: Copyright' },
    { key: 'footer_serving', label: 'Footer: Sirviendo' },
    { key: 'common_read_more', label: 'General: Leer Más' },
    { key: 'common_learn_more', label: 'General: Conoce Más' },
    { key: 'common_view_all', label: 'General: Ver Todos' },
    { key: 'common_request_quote', label: 'General: Solicitar Presupuesto' },
    { key: 'common_request_this_service', label: 'General: Solicitar Servicio' },
    { key: 'common_free_estimate', label: 'General: Estimados Gratis' },
    { key: 'common_free_estimates', label: 'General: Presupuestos Disponibles' },
    { key: 'common_send', label: 'General: Enviar' },
    { key: 'common_sending', label: 'General: Enviando' },
    { key: 'common_success', label: 'General: Éxito' },
    { key: 'common_success_contact', label: 'General: Éxito Contacto' },
    { key: 'common_success_24h', label: 'General: Éxito 24h' },
    { key: 'common_send_another', label: 'General: Enviar Otro' },
    { key: 'common_error', label: 'General: Error' },
    { key: 'common_error_spam', label: 'General: Error Spam' },
    { key: 'common_error_connection', label: 'General: Error Conexión' },
    { key: 'common_years_experience', label: 'General: Años Experiencia' },
    { key: 'common_satisfaction_guaranteed', label: 'General: Satisfacción Garantizada' },
    { key: 'common_local', label: 'General: Negocio Local' },
    { key: 'common_scroll', label: 'General: Desplázate' },
    { key: 'common_full_name', label: 'General: Nombre Completo' },
    { key: 'common_first_name', label: 'General: Nombre' },
    { key: 'common_last_name', label: 'General: Apellido' },
    { key: 'common_email', label: 'General: Email' },
    { key: 'common_phone', label: 'General: Teléfono' },
    { key: 'common_address', label: 'General: Dirección' },
    { key: 'common_service_needed', label: 'General: Servicio Necesario' },
    { key: 'common_message', label: 'General: Mensaje' },
    { key: 'common_select_service', label: 'General: Seleccionar Servicio' },
    { key: 'common_required', label: 'General: Requerido' },
    { key: 'general_consultation', label: 'Servicio: Consulta General' },
    { key: 'spray_foam', label: 'Servicio: Espuma Spray' },
    { key: 'batt_insulation', label: 'Servicio: Paneles' },
    { key: 'roll_insulation', label: 'Servicio: Rollos' },
    { key: 'cellulose_insulation', label: 'Servicio: Celulosa' },
    { key: 'blown_in_insulation', label: 'Servicio: Soplado' },
    { key: 'attic_insulation', label: 'Servicio: Ático' },
    { key: 'wall_insulation', label: 'Servicio: Paredes' },
    { key: 'crawl_space_insulation', label: 'Servicio: Sótano' },
    { key: 'metal_building_insulation', label: 'Servicio: Edificios Metálicos' },
    { key: 'spray_foam_closed', label: 'Servicio: Espuma Celda Cerrada' },
    { key: 'spray_foam_open', label: 'Servicio: Espuma Celda Abierta' },
  ],
  images: [
    { key: 'hero_video', label: 'Hero: Video de Fondo', desc: 'URL del video del hero (MP4)', section: 'Inicio' },
    { key: 'about_preview', label: 'Home About: Imagen', desc: 'Imagen de la sección Sobre Nosotros en Home', section: 'Inicio' },
    { key: 'services_preview_main', label: 'Home Services: Imagen Principal', desc: 'Imagen grande de la sección de servicios', section: 'Inicio' },
    { key: 'services_preview_card1', label: 'Home Services: Tarjeta 1', desc: 'Imagen de Espuma Spray', section: 'Inicio' },
    { key: 'services_preview_card2', label: 'Home Services: Tarjeta 2', desc: 'Imagen de Paneles', section: 'Inicio' },
    { key: 'services_preview_card3', label: 'Home Services: Tarjeta 3', desc: 'Imagen de Celulosa', section: 'Inicio' },
    { key: 'whyus_image', label: 'Why Us: Imagen', desc: 'Imagen lateral de Por Qué Elegirnos', section: 'Inicio' },
    { key: 'cta_banner', label: 'CTA Banner: Imagen', desc: 'Imagen de fondo del banner CTA', section: 'Inicio' },
    { key: 'final_cta', label: 'Final CTA: Imagen', desc: 'Imagen de fondo del CTA final', section: 'Inicio' },
    { key: 'about_hero', label: 'About Page: Hero', desc: 'Imagen del hero de la página Nosotros', section: 'Nosotros' },
    { key: 'about_story', label: 'About Page: Historia', desc: 'Imagen de la sección Nuestra Historia', section: 'Nosotros' },
    { key: 'about_vision', label: 'About Page: Visión', desc: 'Imagen de la sección Visión', section: 'Nosotros' },
    { key: 'about_faq', label: 'About Page: FAQ', desc: 'Imagen de la sección FAQ', section: 'Nosotros' },
    { key: 'about_approach', label: 'About Page: Enfoque', desc: 'Imagen de la sección Enfoque', section: 'Nosotros' },
    { key: 'contact_panel', label: 'Contact: Panel Izquierdo', desc: 'Imagen del panel de contacto', section: 'Contacto' },
    { key: 'contact_bg', label: 'Contact: Fondo', desc: 'Imagen de fondo de la página de contacto', section: 'Contacto' },
    { key: 'svc_spray_foam', label: 'Services: Espuma Spray', desc: 'Imagen del servicio de espuma spray', section: 'Servicios' },
    { key: 'svc_batt', label: 'Services: Paneles', desc: 'Imagen del servicio de paneles', section: 'Servicios' },
    { key: 'svc_cellulose', label: 'Services: Celulosa', desc: 'Imagen del servicio de celulosa', section: 'Servicios' },
    { key: 'svc_attic_walls', label: 'Services: Ático y Paredes', desc: 'Imagen del servicio de ático', section: 'Servicios' },
    { key: 'svc_crawl', label: 'Services: Sótano', desc: 'Imagen del servicio de sótano', section: 'Servicios' },
    { key: 'svc_metal', label: 'Services: Edificios Metálicos', desc: 'Imagen del servicio de edificios metálicos', section: 'Servicios' },
    { key: 'services_area_bg', label: 'Services: Área de Servicio', desc: 'Imagen de fondo de áreas de servicio', section: 'Servicios' },
    { key: 'services_cta_bg', label: 'Services: CTA Fondo', desc: 'Imagen de fondo del CTA de servicios', section: 'Servicios' },
  ],
  stats: [
    { key: 'stats_years_value', label: 'Stats: Años de Experiencia', desc: 'Ej: 15+' },
    { key: 'stats_satisfaction_value', label: 'Stats: Satisfacción', desc: 'Ej: 100%' },
    { key: 'whyus_bar_customer_value', label: 'Barra: Satisfacción Cliente', desc: 'Porcentaje (0-100)' },
    { key: 'whyus_bar_timely_value', label: 'Barra: Proyectos a Tiempo', desc: 'Porcentaje (0-100)' },
    { key: 'whyus_bar_reliable_value', label: 'Barra: Fiabilidad', desc: 'Porcentaje (0-100)' },
    { key: 'whyus_bar_quality_value', label: 'Barra: Calidad', desc: 'Porcentaje (0-100)' },
  ],
};